import { ShapeState } from '../../../cross-team-shared/annotation/shared/state/shape-state';

export function getVisibilityState(shape: ShapeState, frameNumber: number) {
  const closestKeyLocationIndex = getClosestPreviousKeyLocationIndex(
    shape,
    frameNumber,
  );
  if (closestKeyLocationIndex >= 0) {
    return shape.key_locations[closestKeyLocationIndex].visibility;
  }
  return 0;
}

function getClosestPreviousKeyLocationIndex(
  shape: ShapeState,
  frameNumber: number,
) {
  return shape.key_locations.findLastIndex(
    ({ frame_number }) => frame_number <= frameNumber,
  );
}
